export const adminConstants = {
    //Auth
    LOGIN_ADMIN_REQUEST: "LOGIN_ADMIN_REQUEST",
    LOGIN_ADMIN_SUCCESS: "LOGIN_ADMIN_SUCCESS",
    LOGIN_ADMIN_FAILURE: "LOGIN_ADMIN_FAILURE",

    LOGOUT_ADMIN_REQUEST: "LOGOUT_ADMIN_REQUEST",
    LOGOUT_ADMIN_SUCCESS: "LOGOUT_ADMIN_SUCCESS",
    LOGOUT_ADMIN_FAILURE: "LOGOUT_ADMIN_FAILURE",

    GET_MENU_DASHBOARD_REQUEST: "GET_MENU_DASHBOARD_REQUEST",
    GET_MENU_DASHBOARD_SUCCESS: "GET_MENU_DASHBOARD_SUCCESS",
    GET_MENU_DASHBOARD_FAILURE: "GET_MENU_DASHBOARD_FAILURE",

    GET_MENU_REQUEST: "GET_MENU_REQUEST",
    GET_MENU_SUCCESS: "GET_MENU_SUCCESS",
    GET_MENU_FAILURE: "GET_MENU_FAILURE",

    GET_DASHBOARD_REQUEST: "GET_DASHBOARD_REQUEST",
    GET_DASHBOARD_SUCCESS: "GET_DASHBOARD_SUCCESS",
    GET_DASHBOARD_FAILURE: "GET_DASHBOARD_FAILURE",

    PAGINATION_USERS_REQUEST: "PAGINATION_USERS_REQUEST",
    PAGINATION_USERS_SUCCESS: "PAGINATION_USERS_SUCCESS",
    PAGINATION_USERS_FAILURE: "PAGINATION_USERS_FAILURE",
    PAGINATION_ADMIN_USERS_SUCCESS: "PAGINATION_ADMIN_USERS_SUCCESS",

    STORE_USER_REQUEST: "STORE_USER_REQUEST",
    STORE_USER_SUCCESS: "STORE_USER_SUCCESS",
    STORE_USER_FAILURE: "STORE_USER_FAILURE",

    GET_USER_REQUEST: "GET_USER_REQUEST",
    GET_USER_SUCCESS: "GET_USER_SUCCESS",
    GET_USER_FAILURE: "GET_USER_FAILURE",

    GET_USER_PROFILE_REQUEST: "GET_USER_PROFILE_REQUEST",
    GET_USER_PROFILE_SUCCESS: "GET_USER_PROFILE_SUCCESS",
    GET_USER_PROFILE_FAILURE: "GET_USER_PROFILE_FAILURE",

    EDIT_USER_REQUEST: "EDIT_USER_REQUEST",
    EDIT_USER_SUCCESS: "EDIT_USER_SUCCESS",
    EDIT_USER_FAILURE: "EDIT_USER_FAILURE",

    DELETE_USER_REQUEST: "DELETE_USER_REQUEST",
    DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
    DELETE_USER_FAILURE: "DELETE_USER_FAILURE",

    GET_USER_ROLES_REQUEST: "GET_USER_ROLES_REQUEST",
    GET_USER_ROLES_SUCCESS: "GET_USER_ROLES_SUCCESS",
    GET_USER_ROLES_FAILURE: "GET_USER_ROLES_FAILURE",

    GET_AGENCY_ROLES_REQUEST: "GET_AGENCY_ROLES_REQUEST",
    GET_AGENCY_ROLES_SUCCESS: "GET_AGENCY_ROLES_SUCCESS",
    GET_AGENCY_ROLES_FAILURE: "GET_AGENCY_ROLES_FAILURE",

    GET_ALL_PERMISSION_REQUEST: "GET_ALL_PERMISSION_REQUEST",
    GET_ALL_PERMISSION_SUCCESS: "GET_ALL_PERMISSION_SUCCESS",
    GET_ALL_PERMISSION_FAILURE: "GET_ALL_PERMISSION_FAILURE",

    PAGINATION_ROLES_REQUEST: "PAGINATION_ROLES_REQUEST",
    PAGINATION_ROLES_SUCCESS: "PAGINATION_ROLES_SUCCESS",
    PAGINATION_ROLES_FAILURE: "PAGINATION_ROLES_FAILURE",

    STORE_ROLE_REQUEST: "STORE_ROLE_REQUEST",
    STORE_ROLE_SUCCESS: "STORE_ROLE_SUCCESS",
    STORE_ROLE_FAILURE: "STORE_ROLE_FAILURE",

    GET_ROLE_REQUEST: "GET_ROLE_REQUEST",
    GET_ROLE_SUCCESS: "GET_ROLE_SUCCESS",
    GET_ROLE_FAILURE: "GET_ROLE_FAILURE",

    EDIT_ROLE_REQUEST: "EDIT_ROLE_REQUEST",
    EDIT_ROLE_SUCCESS: "EDIT_ROLE_SUCCESS",
    EDIT_ROLE_FAILURE: "EDIT_ROLE_FAILURE",

    DELETE_ROLE_REQUEST: "DELETE_ROLE_REQUEST",
    DELETE_ROLE_SUCCESS: "DELETE_ROLE_SUCCESS",
    DELETE_ROLE_FAILURE: "DELETE_ROLE_FAILURE",

    PAGINATION_PERMISSIONS_REQUEST: "PAGINATION_PERMISSIONS_REQUEST",
    PAGINATION_PERMISSIONS_SUCCESS: "PAGINATION_PERMISSIONS_SUCCESS",
    PAGINATION_PERMISSIONS_FAILURE: "PAGINATION_PERMISSIONS_FAILURE",

    STORE_PERMISSION_REQUEST: "STORE_PERMISSION_REQUEST",
    STORE_PERMISSION_SUCCESS: "STORE_PERMISSION_SUCCESS",
    STORE_PERMISSION_FAILURE: "STORE_PERMISSION_FAILURE",

    GET_PERMISSION_REQUEST: "GET_PERMISSION_REQUEST",
    GET_PERMISSION_SUCCESS: "GET_PERMISSION_SUCCESS",
    GET_PERMISSION_FAILURE: "GET_PERMISSION_FAILURE",

    EDIT_PERMISSION_REQUEST: "EDIT_PERMISSION_REQUEST",
    EDIT_PERMISSION_SUCCESS: "EDIT_PERMISSION_SUCCESS",
    EDIT_PERMISSION_FAILURE: "EDIT_PERMISSION_FAILURE",

    DELETE_PERMISSION_REQUEST: "DELETE_PERMISSION_REQUEST",
    DELETE_PERMISSION_SUCCESS: "DELETE_PERMISSION_SUCCESS",
    DELETE_PERMISSION_FAILURE: "DELETE_PERMISSION_FAILURE",

    GET_ALL_PARENT_LABEL_REQUEST: "GET_ALL_PARENT_LABEL_REQUEST",
    GET_ALL_PARENT_LABEL_SUCCESS: "GET_ALL_PARENT_LABEL_SUCCESS",
    GET_ALL_PARENT_LABEL_FAILURE: "GET_ALL_PARENT_LABEL_FAILURE",

    GET_ALREADY_EXISTING_ORDER_REQUEST: "GET_ALREADY_EXISTING_ORDER_REQUEST",
    GET_ALREADY_EXISTING_ORDER_SUCCESS: "GET_ALREADY_EXISTING_ORDER_SUCCESS",
    GET_ALREADY_EXISTING_ORDER_FAILURE: "GET_ALREADY_EXISTING_ORDER_FAILURE",

    PAGINATION_AGENCIES_REQUEST: "PAGINATION_AGENCIES_REQUEST",
    PAGINATION_AGENCIES_SUCCESS: "PAGINATION_AGENCIES_SUCCESS",
    PAGINATION_AGENCIES_FAILURE: "PAGINATION_AGENCIES_FAILURE",

    STORE_AGENCY_REQUEST: "STORE_AGENCY_REQUEST",
    STORE_AGENCY_SUCCESS: "STORE_AGENCY_SUCCESS",
    STORE_AGENCY_FAILURE: "STORE_AGENCY_FAILURE",

    GET_AGENCY_REQUEST: "GET_AGENCY_REQUEST",
    GET_AGENCY_SUCCESS: "GET_AGENCY_SUCCESS",
    GET_AGENCY_FAILURE: "GET_AGENCY_FAILURE",

    EDIT_AGENCY_REQUEST: "EDIT_AGENCY_REQUEST",
    EDIT_AGENCY_SUCCESS: "EDIT_AGENCY_SUCCESS",
    EDIT_AGENCY_FAILURE: "EDIT_AGENCY_FAILURE",

    DELETE_AGENCY_REQUEST: "DELETE_AGENCY_REQUEST",
    DELETE_AGENCY_SUCCESS: "DELETE_AGENCY_SUCCESS",
    DELETE_AGENCY_FAILURE: "DELETE_AGENCY_FAILURE",

    GET_AGENCY_TYPE_REQUEST: "GET_AGENCY_TYPE_REQUEST",
    GET_AGENCY_TYPE_SUCCESS: "GET_AGENCY_TYPE_SUCCESS",
    GET_AGENCY_TYPE_FAILURE: "GET_AGENCY_TYPE_FAILURE",

    GET_COUNTRIES_REQUEST: "GET_COUNTRIES_REQUEST",
    GET_COUNTRIES_SUCCESS: "GET_COUNTRIES_SUCCESS",
    GET_COUNTRIES_FAILURE: "GET_COUNTRIES_FAILURE",

    GET_PRIMARY_STATES_REQUEST: "GET_PRIMARY_STATES_REQUEST",
    GET_PRIMARY_STATES_SUCCESS: "GET_PRIMARY_STATES_SUCCESS",
    GET_PRIMARY_STATES_FAILURE: "GET_PRIMARY_STATES_FAILURE",

    GET_SECONDARY_STATES_REQUEST: "GET_SECONDARY_STATES_REQUEST",
    GET_SECONDARY_STATES_SUCCESS: "GET_SECONDARY_STATES_SUCCESS",
    GET_SECONDARY_STATES_FAILURE: "GET_SECONDARY_STATES_FAILURE",

    GET_STATES_REQUEST: "GET_STATES_REQUEST",
    GET_STATES_SUCCESS: "GET_STATES_SUCCESS",
    GET_STATES_FAILURE: "GET_STATES_FAILURE",

    GET_SALES_REP_REQUEST: "GET_SALES_REP_REQUEST",
    GET_SALES_REP_SUCCESS: "GET_SALES_REP_SUCCESS",
    GET_SALES_REP_FAILURE: "GET_SALES_REP_FAILURE",

    GET_AGENCY_SALES_REP_REQUEST: "GET_AGENCY_SALES_REP_REQUEST",
    GET_AGENCY_SALES_REP_SUCCESS: "GET_AGENCY_SALES_REP_SUCCESS",
    GET_AGENCY_SALES_REP_FAILURE: "GET_AGENCY_SALES_REP_FAILURE",

    GET_PROGRAM_TYPE_REQUEST: "GET_PROGRAM_TYPE_REQUEST",
    GET_PROGRAM_TYPE_SUCCESS: "GET_PROGRAM_TYPE_SUCCESS",
    GET_PROGRAM_TYPE_FAILURE: "GET_PROGRAM_TYPE_FAILURE",

    GET_MAIN_PROGRAM_TYPE_REQUEST: "GET_MAIN_PROGRAM_TYPE_REQUEST",
    GET_MAIN_PROGRAM_TYPE_SUCCESS: "GET_MAIN_PROGRAM_TYPE_SUCCESS",
    GET_MAIN_PROGRAM_TYPE_FAILURE: "GET_MAIN_PROGRAM_TYPE_FAILURE",

    GET_PROGRAM_ITEM_REQUEST: "GET_PROGRAM_ITEM_REQUEST",
    GET_PROGRAM_ITEM_SUCCESS: "GET_PROGRAM_ITEM_SUCCESS",
    GET_PROGRAM_ITEM_FAILURE: "GET_PROGRAM_ITEM_FAILURE",

    GET_INVOICING_REQUEST: "GET_INVOICING_REQUEST",
    GET_INVOICING_SUCCESS: "GET_INVOICING_SUCCESS",
    GET_INVOICING_FAILURE: "GET_INVOICING_FAILURE",

    CHANGE_AGENCY_STATUS_REQUEST: "CHANGE_AGENCY_STATUS_REQUEST",
    CHANGE_AGENC_STATUS_SUCCESS: "CHANGE_AGENC_STATUS_SUCCESS",
    CHANGE_AGENC_STATUS_FAILURE: "CHANGE_AGENC_STATUS_FAILURE",

    PAGINATION_AGENCY_USERS_REQUEST: "PAGINATION_AGENCY_USERS_REQUEST",
    PAGINATION_AGENCY_USERS_SUCCESS: "PAGINATION_AGENCY_USERS_SUCCESS",
    PAGINATION_AGENCY_USERS_FAILURE: "PAGINATION_AGENCY_USERS_FAILURE",

    GELL_ALL_AGENCY_USER_REQUEST: "GELL_ALL_AGENCY_USER_REQUEST",
    GELL_ALL_AGENCY_USER_SUCCESS: "GELL_ALL_AGENCY_USER_SUCCESS",
    GELL_ALL_AGENCY_USER_FAILURE: "GELL_ALL_AGENCY_USER_FAILURE",

    STORE_AGENCY_USER_REQUEST: "STORE_AGENCY_USER_REQUEST",
    STORE_AGENCY_USER_SUCCESS: "STORE_AGENCY_USER_SUCCESS",
    STORE_AGENCY_USER_FAILURE: "STORE_AGENCY_USER_FAILURE",

    GET_AGENCY_USER_REQUEST: "GET_AGENCY_USER_REQUEST",
    GET_AGENCY_USER_SUCCESS: "GET_AGENCY_USER_SUCCESS",
    GET_AGENCY_USER_FAILURE: "GET_AGENCY_USER_FAILURE",

    EDIT_AGENCY_USER_REQUEST: "EDIT_AGENCY_USER_REQUEST",
    EDIT_AGENCY_USER_SUCCESS: "EDIT_AGENCY_USER_SUCCESS",
    EDIT_AGENCY_USER_FAILURE: "EDIT_AGENCY_USER_FAILURE",

    DELETE_AGENCY_USER_REQUEST: "DELETE_AGENCY_USER_REQUEST",
    DELETE_AGENCY_USER_SUCCESS: "DELETE_AGENCY_USER_SUCCESS",
    DELETE_AGENCY_USER_FAILURE: "DELETE_AGENCY_USER_FAILURE",

    PAGINATION_AGENCY_RESOURCES_REQUEST: "PAGINATION_AGENCY_RESOURCES_REQUEST",
    PAGINATION_AGENCY_RESOURCES_SUCCESS: "PAGINATION_AGENCY_RESOURCES_SUCCESS",
    PAGINATION_AGENCY_RESOURCES_FAILURE: "PAGINATION_AGENCY_RESOURCES_FAILURE",

    STORE_AGENCY_RESOURCE_REQUEST: "STORE_AGENCY_RESOURCE_REQUEST",
    STORE_AGENCY_RESOURCE_SUCCESS: "STORE_AGENCY_RESOURCE_SUCCESS",
    STORE_AGENCY_RESOURCE_FAILURE: "STORE_AGENCY_RESOURCE_FAILURE",

    GET_AGENCY_RESOURCE_REQUEST: "GET_AGENCY_RESOURCE_REQUEST",
    GET_AGENCY_RESOURCE_SUCCESS: "GET_AGENCY_RESOURCE_SUCCESS",
    GET_AGENCY_RESOURCE_FAILURE: "GET_AGENCY_RESOURCE_FAILURE",

    GET_AGENCY_RESOURCE_TYPE_REQUEST: "GET_AGENCY_RESOURCE_TYPE_REQUEST",
    GET_AGENCY_RESOURCE_TYPE_SUCCESS: "GET_AGENCY_RESOURCE_TYPE_SUCCESS",
    GET_AGENCY_RESOURCE_TYPE_FAILURE: "GET_AGENCY_RESOURCE_TYPE_FAILURE",

    EDIT_AGENCY_RESOURCE_REQUEST: "EDIT_AGENCY_RESOURCE_REQUEST",
    EDIT_AGENCY_RESOURCE_SUCCESS: "EDIT_AGENCY_RESOURCE_SUCCESS",
    EDIT_AGENCY_RESOURCE_FAILURE: "EDIT_AGENCY_RESOURCE_FAILURE",

    DELETE_AGENCY_RESOURCE_REQUEST: "DELETE_AGENCY_RESOURCE_REQUEST",
    DELETE_AGENCY_RESOURCE_SUCCESS: "DELETE_AGENCY_RESOURCE_SUCCESS",
    DELETE_AGENCY_RESOURCE_FAILURE: "DELETE_AGENCY_RESOURCE_FAILURE",

    GET_PROGRAM_ITEMS_REQUEST: "GET_PROGRAM_ITEMS_REQUEST",
    GET_PROGRAM_ITEMS_SUCCESS: "GET_PROGRAM_ITEMS_SUCCESS",
    GET_PROGRAM_ITEMS_FAILURE: "GET_PROGRAM_ITEMS_FAILURE",

    GET_SETTING_VALUE_REQUEST: "GET_SETTING_VALUE_REQUEST",
    GET_SETTING_VALUE_SUCCESS: "GET_SETTING_VALUE_SUCCESS",
    GET_SETTING_VALUE_FAILURE: "GET_SETTING_VALUE_FAILURE",

    PAGINATION_ORDERS_REQUEST: "PAGINATION_ORDERS_REQUEST",
    PAGINATION_ORDERS_SUCCESS: "PAGINATION_ORDERS_SUCCESS",
    PAGINATION_ORDERS_FAILURE: "PAGINATION_ORDERS_FAILURE",

    PAGINATION_CARTS_SUCCESS: "PAGINATION_CARTS_SUCCESS",

    GET_CART_DETAILS_SUCCESS: "GET_CART_DETAILS_SUCCESS",

    STORE_ORDER_REQUEST: "STORE_ORDER_REQUEST",
    STORE_ORDER_SUCCESS: "STORE_ORDER_SUCCESS",
    STORE_ORDER_FAILURE: "STORE_ORDER_FAILURE",

    ORDER_RESOURCE_FORMATS_REQUEST: "ORDER_RESOURCE_FORMATS_REQUEST",
    ORDER_RESOURCE_FORMATS_SUCCESS: "ORDER_RESOURCE_FORMATS_SUCCESS",
    ORDER_RESOURCE_FORMATS_FAILURE: "ORDER_RESOURCE_FORMATS_FAILURE",

    GET_ALL_MODULES: "GET_ALL_MODULES",
    STORE_MODULE_REQUEST: "STORE_MODULE_REQUEST",
    STORE_MODULE_SUCCESS: "STORE_MODULE_SUCCESS",
    STORE_MODULE_FAILURE: "STORE_MODULE_FAILURE",
    CHANGE_MODULE_PERMISSIONS: "CHANGE_MODULE_PERMISSIONS",

    GET_USER_PREFERENCE_REQUEST: "GET_USER_PREFERENCE_REQUEST",
    GET_USER_PREFERENCE_SUCCESS: "GET_USER_PREFERENCE_SUCCESS",
    GET_USER_PREFERENCE_FAILURE: "GET_USER_PREFERENCE_FAILURE",

    STORE_PREFERENCE_REQUEST: "STORE_PREFERENCE_REQUEST",
    STORE_PREFERENCE_SUCCESS: "STORE_PREFERENCE_SUCCESS",
    STORE_PREFERENCE_FAILURE: "STORE_PREFERENCE_FAILURE",

    CLEAR_SETTINGS_REQUEST: "CLEAR_SETTINGS_REQUEST",

    GET_ORDER_REQUEST: "GET_ORDER_REQUEST",
    GET_ORDER_SUCCESS: "GET_ORDER_SUCCESS",
    GET_ORDER_FAILURE: "GET_ORDER_FAILURE",

    ORDER_DETAIL_EDIT_REQUEST: "ORDER_DETAIL_EDIT_REQUEST",
    SHIPPING_DETAIL_EDIT_REQUEST: "SHIPPING_DETAIL_EDIT_REQUEST",

    UPLOAD_FILE: "UPLOAD_FILE",
    UPLOAD_FILE_REQUEST: "UPLOAD_FILE_REQUEST",
    UPLOAD_FILE_SUCCESS: "UPLOAD_FILE_SUCCESS",
    ORDER_UPLOAD_CANCEL: "ORDER_UPLOAD_CANCEL",
    LOADING_ORDER_RESOURCES_REQUEST: "LOADING_ORDER_RESOURCES_REQUEST",
    LOADING_ORDER_RESOURCES_SUCCESS: "LOADING_ORDER_RESOURCES_SUCCESS",
    LOADING_ORDER_RESOURCES_FAILURE: "LOADING_ORDER_RESOURCES_FAILURE",

    ORDER_RESOURCE_DELETE_REQUEST: "ORDER_RESOURCE_DELETE_REQUEST",
    ORDER_RESOURCE_DELETE_SUCCESS: "ORDER_RESOURCE_DELETE_SUCCESS",
    ORDER_RESOURCE_DELETE_FAILURE: "ORDER_RESOURCE_DELETE_FAILURE",

    GET_TRIP_ORDER_USERS_REQUEST: "GET_TRIP_ORDER_USERS_REQUEST",
    GET_TRIP_ORDER_USERS_SUCCESS: "GET_TRIP_ORDER_USERS_SUCCESS",
    GET_TRIP_ORDER_USERS_FAILURE: "GET_TRIP_ORDER_USERS_FAILURE",

    GET_FOLLOWING_ORDER_USERS_REQUEST: "GET_FOLLOWING_ORDER_USERS_REQUEST",
    GET_FOLLOWING_ORDER_USERS_SUCCESS: "GET_FOLLOWING_ORDER_USERS_SUCCESS",
    GET_FOLLOWING_ORDER_USERS_FAILURE: "GET_FOLLOWING_ORDER_USERS_FAILURE",

    GET_SPECIAL_ORDER_USER_REQUEST: "GET_SPECIAL_ORDER_USER_REQUEST",
    GET_SPECIAL_ORDER_USER_SUCCESS: "GET_SPECIAL_ORDER_USER_SUCCESS",
    GET_SPECIAL_ORDER_USER_FAILURE: "GET_SPECIAL_ORDER_USER_FAILURE",

    CREATE_SPECIAL_ORDER_USER_REQUEST: "CREATE_SPECIAL_ORDER_USER_REQUEST",
    CREATE_SPECIAL_ORDER_USER_SUCCESS: "CREATE_SPECIAL_ORDER_USER_SUCCESS",
    CREATE_SPECIAL_ORDER_USER_FAILURE: "CREATE_SPECIAL_ORDER_USER_FAILURE",

    UPDATE_SPECIAL_ORDER_USER_SUCCESS: "UPDATE_SPECIAL_ORDER_USER_SUCCESS",
    UPDATE_SPECIAL_ORDER_USER_FAILURE: "UPDATE_SPECIAL_ORDER_USER_FAILURE",

    DELETE_ORDER_USER_REQUEST: "DELETE_ORDER_USER_REQUEST",
    DELETE_ORDER_USER_SUCCESS: "DELETE_ORDER_USER_SUCCESS",
    DELETE_ORDER_USER_FAILURE: "DELETE_ORDER_USER_FAILURE",

    ORDER_USER_UPDATE_REQUEST: "ORDER_USER_UPDATE_REQUEST",
    ORDER_USER_UPDATE_SUCCESS: "ORDER_USER_UPDATE_SUCCESS",
    ORDER_USER_UPDATE_FAILURE: "ORDER_USER_UPDATE_FAILURE",

    APPROVE_ORDER_UPLOAD_REQUEST: "APPROVE_ORDER_UPLOAD_REQUEST",
    APPROVE_ORDER_UPLOAD_SUCCESS: "APPROVE_ORDER_UPLOAD_SUCCESS",
    APPROVE_ORDER_UPLOAD_FAILURE: "APPROVE_ORDER_UPLOAD_FAILURE",

    GET_ORDER_SETTINGS_REQUEST: "GET_ORDER_SETTINGS_REQUEST",
    GET_ORDER_SETTINGS_SUCCESS: "GET_ORDER_SETTINGS_SUCCESS",
    GET_ORDER_SETTINGS_FAILURE: "GET_ORDER_SETTINGS_FAILURE",

    ORDER_HASH_TAG_CHANGE_SUCCESS: "ORDER_HASH_TAG_CHANGE_SUCCESS",
    ORDER_HASH_TAG_CHANGE_FAILURE: "ORDER_HASH_TAG_CHANGE_FAILURE",

    ORDER_MESSAGING_CHANGE_SUCCESS: "ORDER_MESSAGING_CHANGE_SUCCESS",

    ORDER_OPEN_PHOTO_UPLOAD_SUCCESS: "ORDER_OPEN_PHOTO_UPLOAD_SUCCESS",
    ORDER_OPEN_PHOTO_UPLOAD_FAILURE: "ORDER_OPEN_PHOTO_UPLOAD_FAILURE",

    ORDER_MAX_PHOTO_UPLOAD_SUCCESS: "ORDER_MAX_PHOTO_UPLOAD_SUCCESS",
    ORDER_MAX_PHOTO_UPLOAD_FAILURE: "ORDER_MAX_PHOTO_UPLOAD_FAILURE",

    ORDER_AUTO_APPROVE_PHOTOS_SUCCESS: "ORDER_AUTO_APPROVE_PHOTOS_SUCCESS",
    ORDER_AUTO_APPROVE_PHOTOS_FAILURE: "ORDER_AUTO_APPROVE_PHOTOS_FAILURE",

    ORDER_APPROVE_VIDEO_UPLOAD_SUCCESS: "ORDER_APPROVE_VIDEO_UPLOAD_SUCCESS",
    ORDER_APPROVE_VIDEO_UPLOAD_FAILURE: "ORDER_APPROVE_VIDEO_UPLOAD_FAILURE",

    ORDER_UPLOAD_CUT_OFF_DATE_SUCCESS: "ORDER_UPLOAD_CUT_OFF_DATE_SUCCESS",
    ORDER_UPLOAD_CUT_OFF_DATE_FAILURE: "ORDER_UPLOAD_CUT_OFF_DATE_FAILURE",

    GET_USERS_ORDER_REQUEST: "GET_USERS_ORDER_REQUEST",
    GET_USERS_ORDER_SUCCESS: "GET_USERS_ORDER_SUCCESS",
    GET_USERS_ORDER_FAILURE: "GET_USERS_ORDER_FAILURE",

    UPDATE_USERS_MODERATOR_REQUEST: "UPDATE_USERS_MODERATOR_REQUEST",
    UPDATE_USERS_MODERATOR_SUCCESS: "UPDATE_USERS_MODERATOR_SUCCESS",
    UPDATE_USERS_MODERATOR_FAILURE: "UPDATE_USERS_MODERATOR_FAILURE",

    UPDATE_ORDER_VIDEO_TITLES_SUCCESS: "UPDATE_ORDER_VIDEO_TITLES_SUCCESS",
    UPDATE_ORDER_VIDEO_TITLES_FAILURE: "UPDATE_ORDER_VIDEO_TITLES_FAILURE",

    UPDATE_ORDER_EQUIPMENT_UPLOAD_SUCCESS:
        "UPDATE_ORDER_EQUIPMENT_UPLOAD_SUCCESS",
    UPDATE_ORDER_EQUIPMENT_UPLOAD_FAILURE:
        "UPDATE_ORDER_EQUIPMENT_UPLOAD_FAILURE",

    UPDATE_ORDER_CAMERA_SHIP_STATUS_SUCCESS:
        "UPDATE_ORDER_CAMERA_SHIP_STATUS_SUCCESS",

    UPDATE_ORDER_VIDEO_SHIP_STATUS_SUCCESS:
        "UPDATE_ORDER_VIDEO_SHIP_STATUS_SUCCESS",

    UPDATE_ORDER_MOSAIC_SHIP_STATUS_SUCCESS:
        "UPDATE_ORDER_MOSAIC_SHIP_STATUS_SUCCESS",

    UPDATE_ORDER_CAMERA_SHIP_STATUS_FAILURE:
        "UPDATE_ORDER_CAMERA_SHIP_STATUS_FAILURE",

    UPDATE_ORDER_RETURN_SHIP_STATUS_SUCCESS:
        "UPDATE_ORDER_RETURN_SHIP_STATUS_SUCCESS",

    GET_ALL_SHIPPING_METHODS_SUCCESS: "GET_ALL_SHIPPING_METHODS_SUCCESS",
    GET_ALL_SHIPPING_METHODS_FAILURE: "GET_ALL_SHIPPING_METHODS_FAILURE",

    GET_COMMENT_CATEGORIES_SUCCESS: "GET_COMMENT_CATEGORIES_SUCCESS",
    GET_COMMENT_CATEGORIES_FAILURE: "GET_COMMENT_CATEGORIES_FAILURE",

    GET_ALL_COMMENTS_SUCCESS: "GET_ALL_COMMENTS_SUCCESS",
    GET_ALL_COMMENTS_FAILURE: "GET_ALL_COMMENTS_FAILURE",

    DELETE_COMMENT_SUCCESS: "DELETE_COMMENT_SUCCESS",
    DELETE_COMMENT_FAILURE: "DELETE_COMMENT_FAILURE",

    ADD_COMMENT_SUCCESS: "ADD_COMMENT_SUCCESS",
    ADD_COMMENT_FAILURE: "ADD_COMMENT_FAILURE",

    EDIT_COMMENT_SUCCESS: "EDIT_COMMENT_SUCCESS",
    EDIT_COMMENT_FAILURE: "EDIT_COMMENT_FAILURE",

    UPDATE_ORDER_DETAIL_SUCCESS: "UPDATE_ORDER_DETAIL_SUCCESS",
    UPDATE_ORDER_DETAIL_FAILURE: "UPDATE_ORDER_DETAIL_FAILURE",

    UPDATE_PRICING_DETAIL_SUCCESS: "UPDATE_PRICING_DETAIL_SUCCESS",
    UPDATE_PRICING_DETAIL_FAILURE: "UPDATE_PRICING_DETAIL_FAILURE",

    UPDATE_SHIPPING_DETAIL_SUCCESS: "UPDATE_SHIPPING_DETAIL_SUCCESS",
    UPDATE_SHIPPING_DETAIL_FAILURE: "UPDATE_SHIPPING_DETAIL_FAILURE",

    GET_ALL_CAMERAS_TO_SHIP_SUCCESS: "GET_ALL_CAMERAS_TO_SHIP_SUCCESS",
    GET_ALL_CAMERAS_TO_SHIP_FAILURE: "GET_ALL_CAMERAS_TO_SHIP_FAILURE",

    GET_ORDER_IMAGES_REQUEST: "GET_ORDER_IMAGES_REQUEST",
    GET_ORDER_IMAGES_SUCCESS: "GET_ORDER_IMAGES_SUCCESS",
    GET_ORDER_IMAGES_FAILURE: "GET_ORDER_IMAGES_FAILURE",

    TOGGLE_COMMENT_HIGHLIGHT_SUCCESS: "TOGGLE_COMMENT_HIGHLIGHT_SUCCESS",
    TOGGLE_COMMENT_HIGHLIGHT_FAILURE: "TOGGLE_COMMENT_HIGHLIGHT_FAILURE",

    GET_ALL_ORDER_PHASE_IMAGES_REQUEST: "GET_ALL_ORDER_PHASE_IMAGES_REQUEST",
    GET_ALL_ORDER_PHASE_IMAGES_SUCCESS: "GET_ALL_ORDER_PHASE_IMAGES_SUCCESS",
    GET_ALL_ORDER_PHASE_IMAGES_FAILURE: "GET_ALL_ORDER_PHASE_IMAGES_FAILURE",

    GET_ALL_HOLIDAYS_SUCCESS: "GET_ALL_HOLIDAYS_SUCCESS",
    GET_ALL_HOLIDAYS_FAILURE: "GET_ALL_HOLIDAYS_FAILURE",

    GET_ALL_REQUIRED_ASSESTS_SUCCESS: "GET_ALL_REQUIRED_ASSESTS_SUCCESS",
    GET_ALL_REQUIRED_ASSESTS_FAILURE: "GET_ALL_REQUIRED_ASSESTS_FAILURE",

    GET_ALL_RECENTLY_PROCESSED_ORDERS_SUCCESS:
        "GET_ALL_RECENTLY_PROCESSED_ORDERS_SUCCESS",
    GET_ALL_RECENTLY_PROCESSED_ORDERS_FAILURE:
        "GET_ALL_RECENTLY_PROCESSED_ORDERS_FAILURE",

    GET_ALL_BRANDS_SUCCESS: "GET_ALL_BRANDS_SUCCESS",
    GET_ALL_BRANDS_FAILURE: "GET_ALL_BRANDS_FAILURE",

    GET_ALL_ITEM_CATEGORIES_SUCCESS: "GET_ALL_ITEM_CATEGORIES_SUCCESS",
    GET_ALL_ITEM_CATEGORIES_FAILURE: "GET_ALL_ITEM_CATEGORIES_FAILURE",

    STORE_PROGRAM_TYPE_SUCCESS: "STORE_PROGRAM_TYPE_SUCCESS",
    STORE_PROGRAM_TYPE_FAILURE: "STORE_PROGRAM_TYPE_FAILURE",

    UPDATE_PROGRAM_TYPE_SUCCESS: "UPDATE_PROGRAM_TYPE_SUCCESS",
    UPDATE_PROGRAM_TYPE_FAILURE: "UPDATE_PROGRAM_TYPE_FAILURE",

    DELETE_PROGRAM_TYPE_SUCCESS: "DELETE_PROGRAM_TYPE_SUCCESS",
    DELETE_PROGRAM_TYPE_FAILURE: "DELETE_PROGRAM_TYPE_FAILURE",

    GET_SINGLE_PROGRAM_TYPE_SUCCESS: "GET_SINGLE_PROGRAM_TYPE_SUCCESS",
    GET_SINGLE_PROGRAM_TYPE_FAILURE: "GET_SINGLE_PROGRAM_TYPE_FAILURE",

    GET_PROGRAM_TYPES_PAGINATION_SUCCESS:
        "GET_PROGRAM_TYPES_PAGINATION_SUCCESS",
    GET_PROGRAM_TYPES_PAGINATION_FAILURE:
        "GET_PROGRAM_TYPES_PAGINATION_FAILURE",

    GET_AGENCY_TYPES_PAGINATION_SUCCESS: "GET_AGENCY_TYPES_PAGINATION_SUCCESS",
    GET_AGENCY_TYPES_PAGINATION_FAILURE: "GET_AGENCY_TYPES_PAGINATION_FAILURE",

    GET_AGENCY_TYPES_SINGLE_SUCCESS: "GET_AGENCY_TYPES_SINGLE_SUCCESS",
    GET_AGENCY_TYPES_SINGLE_FAILURE: "GET_AGENCY_TYPES_SINGLE_FAILURE",

    STORE_AGENCY_TYPES_SINGLE_SUCCESS: "STORE_AGENCY_TYPES_SINGLE_SUCCESS",
    STORE_AGENCY_TYPES_SINGLE_FAILURE: "STORE_AGENCY_TYPES_SINGLE_FAILURE",

    UPDATE_AGENCY_TYPES_SINGLE_SUCCESS: "UPDATE_AGENCY_TYPES_SINGLE_SUCCESS",
    UPDATE_AGENCY_TYPES_SINGLE_FAILURE: "UPDATE_AGENCY_TYPES_SINGLE_FAILURE",

    DELETE_AGENCY_TYPES_SINGLE_SUCCESS: "DELETE_AGENCY_TYPES_SINGLE_SUCCESS",
    DELETE_AGENCY_TYPES_SINGLE_FAILURE: "DELETE_AGENCY_TYPES_SINGLE_FAILURE",

    STORE_EDITOR_ORDER_IMG_REQUEST: "STORE_EDITOR_ORDER_IMG_REQUEST",
    STORE_EDITOR_ORDER_IMG_SUCCESS: "STORE_EDITOR_ORDER_IMG_SUCCESS",
    STORE_EDITOR_ORDER_IMG_FAILURE: "STORE_EDITOR_ORDER_IMG_FAILURE",

    GET_SETTING_BY_MODEL_ID_REQUEST: "GET_SETTING_BY_MODEL_ID_REQUEST",
    GET_SETTING_BY_MODEL_ID_SUCCESS: "GET_SETTING_BY_MODEL_ID_SUCCESS",
    GET_SETTING_BY_MODEL_ID_FAILURE: "GET_SETTING_BY_MODEL_ID_FAILURE",

    STORE_SETTINGS_DATA_REQUEST: "STORE_SETTINGS_DATA_REQUEST",
    STORE_SETTINGS_DATA_SUCCESS: "STORE_SETTINGS_DATA_SUCCESS",
    STORE_SETTINGS_DATA_FAILURE: "STORE_SETTINGS_DATA_FAILURE",

    UPDATE_SETTINGS_DATA_REQUEST: "UPDATE_SETTINGS_DATA_REQUEST",
    UPDATE_SETTINGS_DATA_SUCCESS: "UPDATE_SETTINGS_DATA_SUCCESS",
    UPDATE_SETTINGS_DATA_FAILURE: "UPDATE_SETTINGS_DATA_FAILURE",

    ASSIGN_USER_TO_ORDER_REQUEST: "ASSIGN_USER_TO_ORDER_REQUEST",
    ASSIGN_USER_TO_ORDER_SUCCESS: "ASSIGN_USER_TO_ORDER_SUCCESS",
    ASSIGN_USER_TO_ORDER_FAILURE: "ASSIGN_USER_TO_ORDER_FAILURE",

    GET_ADDITIONAL_SERVICES_SUCCESS: "GET_ADDITIONAL_SERVICES_SUCCESS",
    GET_ADDITIONAL_SERVICES_FAILURE: "GET_ADDITIONAL_SERVICES_FAILURE",

    GET_SINGLE_ADDITIONAL_ITEM_SUCCESS: "GET_SINGLE_ADDITIONAL_ITEM_SUCCESS",
    GET_SINGLE_ADDITIONAL_ITEM_FAILURE: "GET_SINGLE_ADDITIONAL_ITEM_FAILURE",

    UPDATE_SINGLE_ADDITIONAL_ITEM_SUCCESS:
        "UPDATE_SINGLE_ADDITIONAL_ITEM_SUCCESS",
    UPDATE_SINGLE_ADDITIONAL_ITEM_FAILURE:
        "UPDATE_SINGLE_ADDITIONAL_ITEM_FAILURE",

    DELETE_SINGLE_ADDITIONAL_ITEM_SUCCESS:
        "DELETE_SINGLE_ADDITIONAL_ITEM_SUCCESS",
    DELETE_SINGLE_ADDITIONAL_ITEM_FAILURE:
        "DELETE_SINGLE_ADDITIONAL_ITEM_FAILURE",

    UPDATE_ORDER_SETTINGS_SUCCESS: "UPDATE_ORDER_SETTINGS_SUCCESS",
    UPDATE_ORDER_SETTINGS_FAILURE: "UPDATE_ORDER_SETTINGS_FAILURE",

    GET_INVENTORY_LIST_REQUEST: "GET_INVENTORY_LIST_REQUEST",
    GET_INVENTORY_LIST_SUCCESS: "GET_INVENTORY_LIST_SUCCESS",
    GET_INVENTORY_LIST_FAILURE: "GET_INVENTORY_LIST_FAILURE",

    GET_ITEMS_REQUEST: "GET_ITEMS_REQUEST",
    GET_ITEMS_SUCCESS: "GET_ITEMS_SUCCESS",
    GET_ITEMS_FAILURE: "GET_ITEMS_FAILURE",

    STORE_INVENTORY_REQUEST: "STORE_INVENTORY_REQUEST",
    STORE_INVENTORY_SUCCESS: "STORE_INVENTORY_SUCCESS",
    STORE_INVENTORY_FAILURE: "STORE_INVENTORY_FAILURE",

    GET_INVENTORY_REQUEST: "GET_INVENTORY_REQUEST",
    GET_INVENTORY_SUCCESS: "GET_INVENTORY_SUCCESS",
    GET_INVENTORY_FAILURE: "GET_INVENTORY_FAILURE",

    UPDATE_INVENTORY_REQUEST: "UPDATE_INVENTORY_REQUEST",
    UPDATE_INVENTORY_SUCCESS: "UPDATE_INVENTORY_SUCCESS",
    UPDATE_INVENTORY_FAILURE: "UPDATE_INVENTORY_FAILURE",

    DELETE_INVENTORY_REQUEST: "DELETE_INVENTORY_REQUEST",
    DELETE_INVENTORY_SUCCESS: "DELETE_INVENTORY_SUCCESS",
    DELETE_INVENTORY_FAILURE: "DELETE_INVENTORY_FAILURE",

    STORE_PM_ORDER_VIDEO_SUCCESS: "STORE_PM_ORDER_VIDEO_SUCCESS",
    STORE_PM_ORDER_VIDEO_FAILURE: "STORE_PM_ORDER_VIDEO_FAILURE",

    GET_ORDERS_RESOURCES_BY_ROLE_SUCCESS:
        "GET_ORDERS_RESOURCES_BY_ROLE_SUCCESS",
    GET_ORDERS_RESOURCES_BY_ROLE_FAILURE:
        "GET_ORDERS_RESOURCES_BY_ROLE_FAILURE",

    SET_GLOBAL_LOADER: "SET_GLOBAL_LOADER",
    // CHANGE_TRAVELER_SEE_EVERYONE_STATUS_REQUEST:'',
    // CHANGE_TRAVELER_SEE_EVERYONE_STATUS_SUCCESS:'',
    // CHANGE_TRAVELER_SEE_EVERYONE_STATUS_FAILURE:'',

    // CHANGE_ALL_USERS_MAP_STATUS_REQUEST:'',
    // CHANGE_ALL_USERS_MAP_STATUS_SUCCESS:'',
    // CHANGE_ALL_USERS_MAP_STATUS_FAILURE:'',

    STORE_COUNTRY_REQUEST: "STORE_COUNTRY_REQUEST",
    STORE_COUNTRY_SUCCESS: "STORE_COUNTRY_SUCCESS",
    STORE_COUNTRY_FAILURE: "STORE_COUNTRY_FAILURE",

    PAGINATION_COUNTRIES_REQUEST: "PAGINATION_COUNTRIES_REQUEST",
    PAGINATION_COUNTRIES_SUCCESS: "PAGINATION_COUNTRIES_SUCCESS",
    PAGINATION_COUNTRIES_FAILURE: "PAGINATION_COUNTRIES_FAILURE",

    GET_COUNTRY_REQUEST: "GET_COUNTRY_REQUEST",

    EDIT_COUNTRY_REQUEST: "EDIT_COUNTRY_REQUEST",
    EDIT_COUNTRY_SUCCESS: "EDIT_COUNTRY_SUCCESS",
    EDIT_COUNTRY_FAILURE: "EDIT_COUNTRY_FAILURE",

    DELETE_COUNTRY_REQUEST: "DELETE_COUNTRY_REQUEST",
    DELETE_COUNTRY_SUCCESS: "DELETE_COUNTRY_SUCCESS",
    DELETE_COUNTRY_FAILURE: "DELETE_COUNTRY_FAILURE",

    GET_ALL_COUNTRIES_REQUEST: "GET_ALL_COUNTRIES_REQUEST",
    GET_ALL_COUNTRIES_SUCCESS: "GET_ALL_COUNTRIES_SUCCESS",
    GET_ALL_COUNTRIES_FAILURE: "GET_ALL_COUNTRIES_FAILURE",

    //
    STORE_STATE_REQUEST: "STORE_STATE_REQUEST",
    STORE_STATE_SUCCESS: "STORE_STATE_SUCCESS",
    STORE_STATE_FAILURE: "STORE_STATE_FAILURE",

    PAGINATION_STATES_REQUEST: "PAGINATION_STATES_REQUEST",
    PAGINATION_STATES_SUCCESS: "PAGINATION_STATES_SUCCESS",
    PAGINATION_STATES_FAILURE: "PAGINATION_STATES_FAILURE",

    GET_STATE_REQUEST: "GET_STATE_REQUEST",

    EDIT_STATE_REQUEST: "EDIT_STATE_REQUEST",
    EDIT_STATE_SUCCESS: "EDIT_STATE_SUCCESS",
    EDIT_STATE_FAILURE: "EDIT_STATE_FAILURE",

    DELETE_STATE_REQUEST: "DELETE_STATE_REQUEST",
    DELETE_STATE_SUCCESS: "DELETE_STATE_SUCCESS",
    DELETE_STATE_FAILURE: "DELETE_STATE_FAILURE",

    GET_ALL_STATES_REQUEST: "GET_ALL_STATES_REQUEST",
    GET_ALL_STATES_SUCCESS: "GET_ALL_STATES_SUCCESS",
    GET_ALL_STATES_FAILURE: "GET_ALL_STATES_FAILURE",

    GET_ALL_LIST_TYPES_REQUEST: "GET_ALL_LIST_TYPES_REQUEST",
    GET_ALL_LIST_TYPES_SUCCESS: "GET_ALL_LIST_TYPES_SUCCESS",
    GET_ALL_LIST_TYPES_FAILURE: "GET_ALL_LIST_TYPES_FAILURE",

    STORE_LIST_TYPE_ITEM_REQUEST: "STORE_LIST_TYPE_ITEM_REQUEST",
    STORE_LIST_TYPE_ITEM_SUCCESS: "STORE_LIST_TYPE_ITEM_SUCCESS",
    STORE_LIST_TYPE_ITEM_FAILURE: "STORE_LIST_TYPE_ITEM_FAILURE",

    GET_LIST_TYPE_ITEM_REQUEST: "GET_LIST_TYPE_ITEM_REQUEST",
    GET_LIST_TYPE_ITEM_SUCCESS: "GET_LIST_TYPE_ITEM_SUCCESS",
    GET_LIST_TYPE_ITEM_FAILURE: "GET_LIST_TYPE_ITEM_FAILURE",

    EDIT_LIST_TYPE_ITEM_REQUEST: "EDIT_LIST_TYPE_ITEM_REQUEST",
    EDIT_LIST_TYPE_ITEM_SUCCESS: "EDIT_LIST_TYPE_ITEM_SUCCESS",
    EDIT_LIST_TYPE_ITEM_FAILURE: "EDIT_LIST_TYPE_ITEM_FAILURE",

    DELETE_LIST_TYPE_REQUEST: "DELETE_LIST_TYPE_REQUEST",
    DELETE_LIST_TYPE_SUCCESS: "DELETE_LIST_TYPE_SUCCESS",
    DELETE_LIST_TYPE_FAILURE: "DELETE_LIST_TYPE_FAILURE",

    GET_LIST_REQUEST: "GET_LIST_REQUEST",
    GET_LIST_SUCCESS: "GET_LIST_SUCCESS",
    GET_LIST_FAILURE: "GET_LIST_FAILURE",

    GET_LIST_ITEM_REQUEST: "GET_LIST_ITEM_REQUEST",
    GET_LIST_ITEM_SUCCESS: "GET_LIST_ITEM_SUCCESS",
    GET_LIST_ITEM_FAILURE: "GET_LIST_ITEM_FAILURE",

    STORE_LIST_ITEM_REQUEST: "STORE_LIST_ITEM_REQUEST",
    STORE_LIST_ITEM_SUCCESS: "STORE_LIST_ITEM_SUCCESS",
    STORE_LIST_ITEM_FAILURE: "STORE_LIST_ITEM_FAILURE",

    EDIT_LIST_ITEM_REQUEST: "EDIT_LIST_ITEM_REQUEST",
    EDIT_LIST_ITEM_SUCCESS: "EDIT_LIST_ITEM_SUCCESS",
    EDIT_LIST_ITEM_FAILURE: "EDIT_LIST_ITEM_FAILURE",

    DELETE_LIST_ITEM_REQUEST: "DELETE_LIST_ITEM_REQUEST",
    DELETE_LIST_ITEM_SUCCESS: "DELETE_LIST_ITEM_SUCCESS",
    DELETE_LIST_ITEM_FAILURE: "DELETE_LIST_ITEM_FAILURE",

    STORE_BRAND_REQUEST: "STORE_BRAND_REQUEST",
    STORE_BRAND_SUCCESS: "STOREgetAllListTypesParent_BRAND_SUCCESS",
    STORE_BRAND_FAILURE: "STORE_BRAND_FAILURE",

    STORE_BRAND_PRODUCT_ATTS_REQUEST: "STORE_BRAND_PRODUCT_ATTS_REQUEST",
    STORE_BRAND_PRODUCT_ATTS_SUCCESS: "STORE_BRAND_PRODUCT_ATTS_SUCCESS",
    STORE_BRAND_PRODUCT_ATTS_FAILURE: "STORE_BRAND_PRODUCT_ATTS_FAILURE",

    STORE_BRAND_ORDER_ATTS_REQUEST: "STORE_BRAND_ORDER_ATTS_REQUEST",
    STORE_BRAND_ORDER_ATTS_SUCCESS: "STORE_BRAND_ORDER_ATTS_SUCCESS",
    STORE_BRAND_ORDER_ATTS_FAILURE: "STORE_BRAND_ORDER_ATTS_FAILURE",

    STORE_BRAND_EXPORT_ATTS_REQUEST: "STORE_BRAND_EXPORT_ATTS_REQUEST",
    STORE_BRAND_EXPORT_ATTS_SUCCESS: "STORE_BRAND_EXPORT_ATTS_SUCCESS",
    STORE_BRAND_EXPORT_ATTS_FAILURE: "STORE_BRAND_EXPORT_ATTS_FAILURE",

    GET_ALL_LIST_TYPES_PARENT_REQUEST: "GET_ALL_LIST_TYPES_PARENT_REQUEST",
    GET_ALL_LIST_TYPES_PARENT_SUCCESS: "GET_ALL_LIST_TYPES_PARENT_SUCCESS",
    GET_ALL_LIST_TYPES_PARENT_FAILURE: "GET_ALL_LIST_TYPES_PARENT_FAILURE",

    GET_BRANDS_LIST_REQUEST: "GET_BRANDS_LIST_REQUEST",
    GET_BRANDS_LIST_SUCCESS: "GET_BRANDS_LIST_SUCCESS",
    GET_BRANDS_LIST_FAILURE: "GET_BRANDS_LIST_FAILURE",

    GET_BRANDS_DROPDOWN_LIST_SUCCESS: "GET_BRANDS_DROPDOWN_LIST_SUCCESS",
    GET_CUSTOMER_BRANDS_FOR_CREATE_ORDER_SUCCESS: 'GET_CUSTOMER_BRANDS_FOR_CREATE_ORDER_SUCCESS',

    STORE_CUSTOMER_REQUEST: "STORE_CUSTOMER_REQUEST",
    STORE_CUSTOMER_SUCCESS: "STORE_CUSTOMER_SUCCESS",
    STORE_CUSTOMER_FAILURE: "STORE_CUSTOMER_FAILURE",

    PAGINATION_CUSTOMERS_REQUEST: "PAGINATION_CUSTOMERS_REQUEST",
    PAGINATION_CUSTOMERS_SUCCESS: "PAGINATION_CUSTOMERS_SUCCESS",
    PAGINATION_CUSTOMERS_FAILURE: "PAGINATION_CUSTOMERS_FAILURE",

    CUSTOMERS_DROPDOWN_LIST_SUCCESS: "CUSTOMERS_DROPDOWN_LIST_SUCCESS",

    GET_BRAND_DATA_BYKEY_REQUEST: "GET_BRAND_DATA_BYKEY_REQUEST",
    GET_BRAND_DATA_BYKEY_SUCCESS: "GET_BRAND_DATA_BYKEY_SUCCESS",
    GET_BRAND_DATA_BYKEY_FAILURE: "GET_BRAND_DATA_BYKEY_FAILURE",

    GET_BRAND_PRODUCT_DATA_REQUEST: "GET_BRAND_PRODUCT_DATA_REQUEST",
    GET_BRAND_PRODUCT_DATA_SUCCESS: "GET_BRAND_PRODUCT_DATA_SUCCESS",
    GET_BRAND_PRODUCT_DATA_FAILURE: "GET_BRAND_PRODUCT_DATA_FAILURE",

    GET_BRAND_DATA_FOR_CUSTOMER_REQUEST: "GET_BRAND_PRODUCT_DATA_REQUEST",
    GET_BRAND_DATA_FOR_CUSTOMER_SUCCESS: "GET_BRAND_DATA_FOR_CUSTOMER_SUCCESS",
    GET_BRAND_DATA_FOR_CUSTOMER_FAILURE: "GET_BRAND_DATA_FOR_CUSTOMER_FAILURE",

    GET_ORDER_ATTRIBUTES_SUCCESS: "GET_ORDER_ATTRIBUTES_SUCCESS",

    STORE_CUSTOMER_BRAND_REQUEST: "STORE_CUSTOMER_BRAND_REQUEST",
    STORE_CUSTOMER_BRAND_SUCCESS: "STORE_CUSTOMER_BRAND_SUCCESS",
    STORE_CUSTOMER_BRAND_FAILURE: "STORE_CUSTOMER_BRAND_FAILURE",

    GET_CUSTOMER_BRANDS_REQUEST: "GET_CUSTOMER_BRANDS_REQUEST",
    GET_CUSTOMER_BRANDS_SUCCESS: "GET_CUSTOMER_BRANDS_SUCCESS",
    GET_CUSTOMER_BRANDS_FAILURE: "GET_CUSTOMER_BRANDS_FAILURE",

    DELETE_CUSTOMER_BRAND_SUCCESS: "DELETE_CUSTOMER_BRAND_SUCCESS",
    STORE_SHIPPING_OPTION_SUCCESS: "STORE_SHIPPING_OPTION_SUCCESS",

    GET_SHIPPING_OPTION_REQUEST: "GET_SHIPPING_OPTION_REQUEST",
    GET_SHIPPING_OPTION_SUCCESS: "GET_SHIPPING_OPTION_SUCCESS",
    GET_SHIPPING_OPTION_FAILURE: "GET_SHIPPING_OPTION_FAILURE",

    DELETE_SHIPPING_OPTION_SUCCESS: "DELETE_SHIPPING_OPTION_SUCCESS",

    DELETE_CUSTOMER_SUCCESS: "DELETE_CUSTOMER_SUCCESS",
    STORE_CUSTMER_ADDRESS: "STORE_CUSTMER_ADDRESS",

    PAGINATION_CUST_ADDRESSES_SUCCESS: "PAGINATION_CUST_ADDRESSES_SUCCESS",
    PAGINATION_CUST_ADDRESSES_FAILURE: "PAGINATION_CUST_ADDRESSES_FAILURE",

    GET_ADDRESS_ITEM_SUCCESS: "GET_ADDRESS_ITEM_SUCCESS",
    GET_ADDRESS_ITEM_FAILURE: "GET_ADDRESS_ITEM_FAILURE",

    DELETE_ADDRESS_ITEM_SUCCESS: "DELETE_ADDRESS_ITEM_SUCCESS",
    DELETE_ADDRESS_ITEM_FAILURE: "DELETE_ADDRESS_ITEM_FAILURE",

    STORE_BRAND_DATA_DEFINITION_REQUEST: "STORE_BRAND_DATA_DEFINITION_REQUEST",
    STORE_BRAND_DATA_DEFINITION_SUCCESS: "STORE_BRAND_DATA_DEFINITION_SUCCESS",
    STORE_BRAND_DATA_DEFINITION_FAILURE: "STORE_BRAND_DATA_DEFINITION_FAILURE",

    GET_BRAND_DATA_DEFINITIONS_REQUEST: "GET_BRAND_DATA_DEFINITIONS_REQUEST",
    GET_BRAND_DATA_DEFINITIONS_SUCCESS: "GET_BRAND_DATA_DEFINITIONS_SUCCESS",
    GET_BRAND_DATA_DEFINITIONS_FAILURE: "GET_BRAND_DATA_DEFINITIONS_FAILURE",

    EDIT_BRAND_DATA_DEFINITION_REQUEST: "EDIT_BRAND_DATA_DEFINITION_REQUEST",
    EDIT_BRAND_DATA_DEFINITION_SUCCESS: "EDIT_BRAND_DATA_DEFINITION_SUCCESS",
    EDIT_BRAND_DATA_DEFINITION_FAILURE: "EDIT_BRAND_DATA_DEFINITION_FAILURE",

    GET_CUSTOMER_SUCCESS: "GET_CUSTOMER_SUCCESS",

    PAGINATION_CUST_CONTACTS_SUCCESS: "PAGINATION_CUST_CONTACTS_SUCCESS",
    PAGINATION_CUST_CONTACTS_FAILURE: "PAGINATION_CUST_CONTACTS_FAILURE",
    GET_LOGGED_IN_CUSTOMER_CONTACTS: "GET_LOGGED_IN_CUSTOMER_CONTACTS",

    GET_CONTACT_SUCCESS: "GET_CONTACT_SUCCESS",
    GET_CONTACT_FAILURE: "GET_CONTACT_FAILURE",

    PAGINATION_TAG_LAYOUTS_SUCCESS: "PAGINATION_TAG_LAYOUTS_SUCCESS",
    PAGINATION_TAG_LAYOUTS_FAILURE: "PAGINATION_TAG_LAYOUTS_FAILURE",

    GET_TAG_LAYOUT_SUCCESS: "GET_TAG_LAYOUT_SUCCESS",

    GET_FILTERED_PRODUCTS_SUCCESS: "GET_FILTERED_PRODUCTS_SUCCESS",
    ADD_PRODUCTS_TO_CART_SUCCESS: "ADD_PRODUCTS_TO_CART_SUCCESS",
    GET_SHIPPING_ADDRESSES_SUCCESS: "GET_SHIPPING_ADDRESSES_SUCCESS",
    GET_BILLING_ADDRESSES_SUCCESS: "GET_BILLING_ADDRESSES_SUCCESS",

    GET_ORDER_PRODUCTS_SUCCESS: "GET_ORDER_PRODUCTS_SUCCESS",

    PAGINATION_BRAND_ADDRESSES_SUCCESS: "PAGINATION_BRAND_ADDRESSES_SUCCESS",
    PAGINATION_BRAND_ADDRESSES_FAILURE: "PAGINATION_BRAND_ADDRESSES_FAILURE",

    STORE_BRAND_ADDRESS_SUCCESS: "STORE_BRAND_ADDRESS_SUCCESS",
    DELETE_BRAND_ADDRESS_SUCCESS: "DELETE_BRAND_ADDRESS_SUCCESS",

    GET_BRAND_ADDRESS_ITEM_SUCCESS: "GET_BRAND_ADDRESS_ITEM_SUCCESS",

    STORE_TRANSFORMATION_RULES_REQUEST: "STORE_TRANSFORMATION_RULES_REQUEST",
    STORE_TRANSFORMATION_RULES_SUCCESS: "STORE_TRANSFORMATION_RULES_SUCCESS",
    STORE_TRANSFORMATION_RULES_FAILURE: "STORE_TRANSFORMATION_RULES_FAILURE",

    STORE_BRAND_LOOKUP_TABLE_REQUEST: "STORE_BRAND_LOOKUP_TABLE_REQUEST",
    STORE_BRAND_LOOKUP_TABLE_SUCCESS: "STORE_BRAND_LOOKUP_TABLE_SUCCESS",
    STORE_BRAND_LOOKUP_TABLE_FAILURE: "STORE_BRAND_LOOKUP_TABLE_FAILURE",

    GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_REQUEST:
        "GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_REQUEST",
    GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_SUCCESS:
        "GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_SUCCESS",
    GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_FAILURE:
        "GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_FAILURE",

    GET_BRAND_LOOKUP_DEFINITIONS_DATA_REQUEST:
        "GET_BRAND_LOOKUP_DEFINITIONS_DATA_REQUEST",
    GET_BRAND_LOOKUP_DEFINITIONS_DATA_SUCCESS:
        "GET_BRAND_LOOKUP_DEFINITIONS_DATA_SUCCESS",
    GET_BRAND_LOOKUP_DEFINITIONS_DATA_FAILURE:
        "GET_BRAND_LOOKUP_DEFINITIONS_DATA_FAILURE",

    GET_TRANSFORMATION_RULES_LISTING_REQUEST:
        "GET_TRANSFORMATION_RULES_LISTING_REQUEST",
    GET_TRANSFORMATION_RULES_LISTING_SUCCESS:
        "GET_TRANSFORMATION_RULES_LISTING_SUCCESS",
    GET_TRANSFORMATION_RULES_LISTING_FAILURE:
        "GET_TRANSFORMATION_RULES_LISTING_FAILURE",

    MARK_ACTIVE_VERSION_DEFINITION_REQUEST:
        "MARK_ACTIVE_VERSION_DEFINITION_REQUEST",
    MARK_ACTIVE_VERSION_DEFINITION_SUCCESS:
        "MARK_ACTIVE_VERSION_DEFINITION_SUCCESS",
    MARK_ACTIVE_VERSION_DEFINITION_FAILURE:
        "MARK_ACTIVE_VERSION_DEFINITION_FAILURE",

    SORT_TRANSFORMATION_RULES_REQUEST: "SORT_TRANSFORMATION_RULES_REQUEST",
    SORT_TRANSFORMATION_RULES_SUCCESS: "SORT_TRANSFORMATION_RULES_SUCCESS",
    SORT_TRANSFORMATION_RULES_FAILURE: "SORT_TRANSFORMATION_RULES_FAILURE",

    UPDATE_BRAND_REQUEST: "UPDATE_BRAND_REQUEST",
    UPDATE_BRAND_SUCCESS: "UPDATE_BRAND_SUCCESS",
    UPDATE_BRAND_FAILURE: "UPDATE_BRAND_FAILURE",

    DELETE_BRAND_REQUEST: "DELETE_BRAND_REQUEST",
    DELETE_BRAND_SUCCESS: "DELETE_BRAND_SUCCESS",
    DELETE_BRAND_FAILURE: "DELETE_BRAND_FAILURE",

    DELETE_TRANSFORMATION_RULE_REQUEST: "DELETE_TRANSFORMATION_RULE_REQUEST",
    DELETE_TRANSFORMATION_RULE_SUCCESS: "DELETE_TRANSFORMATION_RULE_SUCCESS",
    DELETE_TRANSFORMATION_RULE_FAILURE: "DELETE_TRANSFORMATION_RULE_FAILURE",

    DELETE_BRAND_DATA_DEFINITION_REQUEST: "DELETE_BRAND_DATA_DEFINITION_REQUEST",
    DELETE_BRAND_DATA_DEFINITION_SUCCESS: "DELETE_BRAND_DATA_DEFINITION_SUCCESS",
    DELETE_BRAND_DATA_DEFINITION_FAILURE: "DELETE_BRAND_DATA_DEFINITION_FAILURE",

    GET_BRAND_SETTINGS_REQUEST: "GET_BRAND_SETTINGS_REQUEST",
    GET_BRAND_SETTINGS_SUCCESS: "GET_BRAND_SETTINGS_SUCCESS",
    GET_BRAND_SETTINGS_FAILURE: "GET_BRAND_SETTINGS_FAILURE",

    UPDATE_BRAND_SETTINGS_REQUEST: "UPDATE_BRAND_SETTINGS_REQUEST",
    UPDATE_BRAND_SETTINGS_SUCCESS: "UPDATE_BRAND_SETTINGS_SUCCESS",
    UPDATE_BRAND_SETTINGS_FAILURE: "UPDATE_BRAND_SETTINGS_FAILURE",

    CHANGE_USER_PASSWORD_REQUEST: 'CHANGE_USER_PASSWORD_REQUEST',
    CHANGE_USER_PASSWORD_SUCCESS: 'CHANGE_USER_PASSWORD_SUCCESS',
    CHANGE_USER_PASSWORD_FAILURE: 'CHANGE_USER_PASSWORD_FAILURE',

    GET_SYNC_ERRORS_LIST_REQUEST: 'GET_SYNC_ERRORS_LIST_REQUEST',
    GET_SYNC_ERRORS_LIST_SUCCESS: 'GET_SYNC_ERRORS_LIST_SUCCESS',
    GET_SYNC_ERRORS_LIST_FAILURE: 'GET_SYNC_ERRORS_LIST_FAILURE',

    GET_SYNC_ERRORS_MESSAGES_LIST_REQUEST: 'GET_SYNC_ERRORS_MESSAGES_LIST_REQUEST',
    GET_SYNC_ERRORS_MESSAGES_LIST_SUCCESS: 'GET_SYNC_ERRORS_MESSAGES_LIST_SUCCESS',
    GET_SYNC_ERRORS_MESSAGES_LIST_FAILURE: 'GET_SYNC_ERRORS_MESSAGES_LIST_FAILURE',

    MARK_ERROR_FIXED_REQUEST: 'MARK_ERROR_FIXED_REQUEST',
    MARK_ERROR_FIXED_SUCCESS: 'MARK_ERROR_FIXED_SUCCESS',
    MARK_ERROR_FIXED_FAILURE: 'MARK_ERROR_FIXED_FAILURE',

    SIGNUP_CUSTOMER_REQUEST: 'SIGNUP_CUSTOMER_REQUEST',
    SIGNUP_CUSTOMER_SUCCESS: 'SIGNUP_CUSTOMER_SUCCESS',
    SIGNUP_CUSTOMER_FAILURE: 'SIGNUP_CUSTOMER_FAILURE',

    SEND_RECOVERY_EMAIL_REQUEST: 'SEND_RECOVERY_EMAIL_REQUEST',
    SEND_RECOVERY_EMAIL_SUCCESS: 'SEND_RECOVERY_EMAIL_SUCCESS',
    SEND_RECOVERY_EMAIL_FAILURE: 'SEND_RECOVERY_EMAIL_FAILURE',

    RESET_USER_PASSWORD_REQUEST: 'RESET_USER_PASSWORD_REQUEST',
    RESET_USER_PASSWORD_SUCCESS: 'RESET_USER_PASSWORD_SUCCESS',
    RESET_USER_PASSWORD_FAILURE: 'RESET_USER_PASSWORD_FAILURE',

    GET_ORDER_STATES_REQUEST: 'GET_ORDER_STATES_REQUEST',
    GET_ORDER_STATES_SUCCESS: 'GET_ORDER_STATES_SUCCESS',
    GET_ORDER_STATES_FAILURE: 'GET_ORDER_STATES_FAILURE',
    
    GET_ERROR_STATES_REQUEST: 'GET_ERROR_STATES_REQUEST',
    GET_ERROR_STATES_SUCCESS: 'GET_ERROR_STATES_SUCCESS',
    GET_ERROR_STATES_FAILURE: 'GET_ERROR_STATES_FAILURE',
    
    GET_ERROR_STATES_FOR_BRAND_REQUEST: 'GET_ERROR_STATES_FOR_BRAND_REQUEST',
    GET_ERROR_STATES_FOR_BRAND_SUCCESS: 'GET_ERROR_STATES_FOR_BRAND_SUCCESS',
    GET_ERROR_STATES_FOR_BRAND_FAILURE: 'GET_ERROR_STATES_FOR_BRAND_FAILURE',


};  



// WEBPACK FOOTER //
// ./src/redux/constant/admin-constant.jsx